<template>
    <ValidationProvider
        :name="$t('formularios.tipo_identificacion') + (index > 0 ? (' ' + index) : '')"
        rules="required"
        v-slot="{ errors }"
    >
        <div class="form-group">
            <label>{{ $t('formularios.tipo_identificacion') }}</label>
            <multiselect
                v-model="localType"
                label="label"
                track-by="type"
                class="custom-multiselect"
                :class="{ 'is-invalid': errors.length }"
                :id="'tipo-documento-' + index"
                :placeholder="$t('formularios.tipo_identificacion')"
                :options="tiposDocumento"
            />
            <span 
                v-if="errors[0]" 
                class="d-block invalid-feedback text-xs bg-danger white h7 mb-4 p-2 font-weight-bold" 
            >
                {{ errors[0] }}
            </span>
        </div>
    </ValidationProvider>
</template>

<script>
    export default {
        name: "DocumentoTipo",
        props: {
            value: {
                type: String,
                default: ''
            },
            index: {
                type: Number,
                default: 0
            }
        },
        data() {
            return {
                tiposDocumento: [
                    { type: 'DNI', label: this.$t('formularios.dni').toUpperCase() },
                    { type: 'NIE', label: this.$t('formularios.nie') },
                    { type: 'NIF', label: this.$t('formularios.nif') },
                    { type: 'PASSPORT', label: this.$t('formularios.pasaporte') }
                ]
            }
        },
        computed: {
            localType: {
                get() {
                    return this.tiposDocumento.find(opt => opt.type === this.value) || null
                },
                set(option) {
                    this.$emit('input', option ? option.type : '')
                }
            }
        }
    }
</script>
